export interface IAddLanguage {
  languageId: number;
  isDefault: boolean;
}
